// extracted by mini-css-extract-plugin
export default {"addButton":"AddReleaseButton_addButton__IILSs","modalAddButton":"AddReleaseButton_modalAddButton__EGJdy"};